<template>
  <div style="padding: 7.375rem 2.5vw 1.5rem; overflow-x: hidden">
    <div class="homework-box">
      <div class="search-box">
        <el-row type="flex" align="bottom" :gutter="20" style="flex-wrap: wrap">
          <el-col :sm="4" :xs="12">
            <div class="input-title">{{ $t("studentProgramme.startDate") }}</div>
            <el-date-picker
              align="center"
              v-model="form.startDate"
              type="date"
              placeholder="DD/MM/YY"
              format="dd/MM/yyyy"
              clearable
              style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col :sm="4" :xs="12">
            <div class="input-title">{{ $t("studentProgramme.endDate") }}</div>
            <el-date-picker
              align="center"
              v-model="form.endDate"
              type="date"
              placeholder="DD/MM/YY"
              format="dd/MM/yyyy"
              clearable
              style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col :xs="9" :sm="9" :lg="10" style="padding-top: 0.625rem">
            <div class="input-title">{{ $t("studentProgramme.search") }}</div>
            <el-input
              class="search"
              :placeholder="$t('studentProgramme.searchForExamKeywords')"
              v-model="form.keywords"
              prefix-icon="el-icon-search"
            ></el-input>
          </el-col>
          <el-col
            :lg="{ span: 5, offset: 1 }"
            :xs="7"
            :sm="7"
            style="display: flex; padding-top: 0.625rem"
          >
            <button
              @click="search"
              class="security-button cursor-pointer"
              style="background-color: #fcc03a; margin-right: 1rem; flex: 3"
            >
              {{ $t("studentProgramme.search") }}
            </button>
            <button
              @click="clearSearch"
              class="security-button cursor-pointer"
              style="flex: 4"
            >
              {{ $t("studentProgramme.clearFilter") }}
            </button>
          </el-col>
        </el-row>
      </div>

      <div class="summary-box">
        <el-table :data="tableData" style="width: 100%" v-if="isPC">
          <el-table-column prop="number" :label="$t('studentProgramme.homework')" min-width="260">
            <template slot-scope="{ row }">
                <div class="ellipsis-text">{{row.number}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="startDate"
            :label="$t('studentProgramme.startDate')"
            width="200"
            :formatter="startFormatter"
          >
          </el-table-column>
          <el-table-column
            prop="endDate"
            :label="$t('studentProgramme.endDate')"
            width="200"
            :formatter="endFormatter"
          >
          </el-table-column>
          <el-table-column
              prop="completedAt"
              :label="$t('studentProgramme.finishDate')"
              width="160"
              :formatter="completedAtFormatter"
          >
          </el-table-column>
          <el-table-column :label="$t('studentProgramme.score')" width="60" align="right">
            <template slot-scope="{ row }">
              <span v-if="row.completedAt">{{
                row.correctQuantity + "/" + row.totalQuantity
              }}</span>
              <span v-else>-/-</span>
            </template>
          </el-table-column>
          <el-table-column width="240" align="center" v-if="tableData.length>0">
            <template slot-scope="scope">
              <button
                v-if="needHomework(scope.row)"
                class="table-button"
                @click="toExamination(scope.row.id,gradeId)"
              >
                開始作業
              </button>
            </template>
          </el-table-column>
          <el-table-column width="40" v-else></el-table-column>
        </el-table>
        <el-table :data="tableData" style="width: 100%" v-else>
            <el-table-column prop="number" label="作業">
            <template slot-scope="{ row }">
                <div class="ellipsis-text">{{row.number}}</div>
            </template>
        </el-table-column>
          <el-table-column
            prop="startDate"
            label="開始時間"
            width="160"
            :formatter="startFormatter"
          >
          </el-table-column>
          <el-table-column
            prop="endDate"
            label="到期時間"
            width="160"
            :formatter="endFormatter"
          >
          </el-table-column>
          <el-table-column
              prop="completedAt"
              label="完成時間"
              width="160"
              :formatter="completedAtFormatter"
          >
          </el-table-column>
          <el-table-column label="分數" width="60" align="right">
            <template slot-scope="{ row }">
              <span v-if="row.completedAt">{{
                row.correctQuantity + "/" + row.totalQuantity
              }}</span>
              <span v-else>-/-</span>
            </template>
          </el-table-column>

          <el-table-column width="200" align="center" v-if="tableData.length>0">
            <template slot-scope="scope">
              <button
                v-if="scope.row.needHomework"
                class="table-button"
                @click="toExamination(scope.row.id,gradeId)"
              >
                開始作業
              </button>
            </template>
          </el-table-column>
          <el-table-column width="40" v-else></el-table-column>
        </el-table>
        <Pagination
          v-show="total > 0"
          :small="$store.getters.isPC ? false : true"
          :total="total"
          :autoScroll="false"
          :page.sync="listQ._page"
          :limit.sync="listQ._limit"
          @pagination="getData"
          layout="pager"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeworks } from "@/api/homework";
import Pagination from "@/components/Pagination";
import { formatDateTime, formatDate2 } from "@/filters";
import { isPC } from "@/utils/is-rules.js";
import moment from "moment";
import {getUserInfo} from "@/utils/auth";
export default {
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  components: { Pagination },
  name: "home",
  data() {
    return {
      isPC: isPC(),
      total: 0,
      gradeId: null,
      form: {
        studentId: null,
        gradeId: null,
        startDate: null,
        endDate: null,
        keywords: null,
      },
      listQ: {
        _page: 1,
        _limit: 20,
      },
      tableData: [],
    };
  },
  watch: {
    "$store.getters.currentGradeId": {
      handler(v) {
        this.gradeId = v;
        this.getData();
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getData();
    this.gradeId = this.$store.getters.currentGradeId;
  },
  methods: {
    toExamination(id,gradeId) {
      this.$router.push({
        path: '/examination',
        query: { type: 'work', id: id, gradeId: gradeId,startTime: moment().format('YYYY-MM-DD HH:mm:ss') },
      });
    },
    getStartTime() {
      return moment().format('YYYY-MM-DD HH:mm:ss')
    },
    getData() {
      let form = {
        studentId: this.form.studentId,
        gradeId: this.form.gradeId || this.gradeId,
        startDate: formatDate2(this.form.startDate),
        endDate: formatDate2(this.form.endDate),
        keywords: this.form.keywords,
        _page: this.listQ._page - 1,
        _limit: this.listQ._limit,
        lang: getUserInfo("userProfile").studying,//this.$store.getters.language == this.languageZhTc?0:1,
      };
      getHomeworks(form).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    startFormatter(row) {
      return formatDateTime(row.startDate) || "---";
    },
    endFormatter(row) {
      return formatDateTime(row.endDate) || "---";
    },
    completedAtFormatter(row) {
      return formatDateTime(row.completedAt) || "---";
    },
    search() {
      this.getData();
    },
    clearSearch() {
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.keywords = "";
      let form = {
        studentId: this.form.studentId,
        gradeId: this.form.gradeId || this.gradeId,
        _page: 0,
        _limit: this.listQ._limit,
        lang: getUserInfo("userProfile").studying,//this.$store.getters.language == this.languageZhTc?0:1,
      };
      getHomeworks(form).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
      needHomework(row) {
      if (row.completedAt) return false;
      else if (row.startDate && row.endDate)
        return this.$options.filters["isBetween2"](
          new Date(),
          row.startDate,
          row.endDate
        );
      else if(!row.endDate) return true
      else return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 6.25vw;
  background: #ffffff;
  border-radius: 2.5rem;
}
.model-box {
  display: flex;
  text-align: center;
  background: white;
  border: 1px #b62d2e solid;
  border-radius: 2rem;
  padding: 0.25rem;
  margin: 1rem;
}
.model-move {
  position: absolute;
  transition: transform 0.4s linear 0s;
  transform: translateX(0%);
  width: 5rem;
  height: 2rem;
  border-radius: 1rem;
  mix-blend-mode: difference;
  background: #00ffff; //#49d2d1;
}
.model-text {
  line-height: 2rem;
  width: 5rem;
  color: #ff0000; //#B62D2E;
  //mix-blend-mode:screen;
  /*background: #49d2d1;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;*/
}
.input-title {
  color: #8e8e8e;
  font-weight: 500;
  line-height: 1.6rem;
  font-family: "GenSenRoundedJP", "Helvetica", "Arial";
}
.security-button {
  //margin:1.25rem 0;
  border: 0.0625rem solid #fcc03a;
  background-color: #ffffff;
  font-weight: bold;
  font-size: 1rem;
  color: #444444;
  border-radius: 1.625rem;
  line-height: 2.625rem;
  height: 2.75rem;
}
.search-box {
  font-size: 0.875rem;
  width: 100%;
}
.summary-box {
  width: 100%;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.table-button {
  background: #fcc03a;
  box-shadow: 0px 0.5rem 0 #c28c00;
  border: none;
  border-radius: 2.75rem;
  font-size: 1.5rem;
  line-height: 2rem;
  display: block;
  margin: 0 auto 0.5rem;
  padding: 0.5rem 2rem;
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .homework-box {
    padding: 1.5rem 6.25vw;
  }
  .summary-box {
    margin-top: 1.5rem;
  }
  .table-button {
    background: #fcc03a;
    box-shadow: 0px 0.5rem 0 #c28c00;
    border: none;
    border-radius: 2.75rem;
    font-size: 1.25rem;
    line-height: 1.5rem;
    display: block;
    margin: 0 auto 0.5rem;
    padding: 0.375rem 1.5rem;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .homework-box {
    padding: 1.5rem 6.25vw;
  }
  .summary-box {
    margin-top: 1.5rem;
  }
  .table-button {
    background: #fcc03a;
    box-shadow: 0px 0.5rem 0 #c28c00;
    border: none;
    border-radius: 2.75rem;
    font-size: 1.25rem;
    line-height: 1.5rem;
    display: block;
    margin: 0 auto 0.5rem;
    padding: 0.375rem 1.5rem;
  }
}
::v-deep {
    .ellipsis-text{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
	overflow: hidden;
	text-overflow: ellipsis;
    }
  .el-select .el-input .el-select__caret {
    color: #b62d2e;
  }
  .el-input__prefix {
    color: #b62d2e;
  }
  .el-date-editor {
    .el-input__prefix {
      left: auto;
      right: 5px;
    }
    .el-input__suffix {
      color: #444444;
      right: 25px;
    }
  }
  .el-input__inner {
    //border-top-right-radius: 3.125rem;
    //border-bottom-right-radius: 3.125rem;
    border-radius: 0.625rem;
    //background-color: #fffbed;
    border: 0.0625rem solid #8e8e8e;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .search .el-input__inner {
    padding-left: 30px;
  }
  .el-icon-search {
    background: url("~@/assets/images/search2.png") center center/contain
      no-repeat;
  }
  .el-icon-search:before {
    content: "";
  }
  .el-table {
    font-size: 1rem;
    /*th + th, td + td{
        margin-right:2rem;
      }*/
  }
  .el-table .cell {
    padding: 0;
    line-height: 3.5rem;
  }
  .el-table th.el-table__cell > .cell {
    padding: 0;
  }
  .el-table th {
    background: #fceedd;
    color: #444444;
  }
  .el-table th:first-child {
    padding-left: 3rem;
  }
  .el-table td:first-child {
    padding-left: 3rem;
  }
}
</style>
